import { gql } from '@at/sauron-platform-graphql'

export const SearchResultsFacetsWithGroupsQueryWithGroupsGql = gql`
    query SearchResultsFacetsWithGroupsQuery(
        $facets: [FacetName!]!
        $filters: [FilterInput!]!
        $channel: Channel!
        $sortBy: SearchResultsSort
        $facetGroups: [FacetGroupName!]!
        $useSearchEvoFacets: Boolean
        $useGridLayout: Boolean
        $featureFlags: [FeatureFlag]
    ) {
        searchResults(
            input: {
                facets: $facets
                filters: $filters
                channel: $channel
                sortBy: $sortBy
                useSearchEvoFacets: $useSearchEvoFacets
                useGridLayout: $useGridLayout
                featureFlags: $featureFlags
            }
        ) {
            sortBy {
                selected
                options {
                    name
                    value
                    descriptionTooltipText
                }
            }
            facets {
                facet
                filters {
                    filter
                    options {
                        label
                        value
                        count
                        description
                    }
                    selected
                    isOnlySelected
                    sections {
                        label
                        values
                    }
                }
            }
            facetGroups(facetGroupNames: $facetGroups, filters: $filters) {
                facetGroupName
                status
                selectedValuesSummary
                title
                helpText
                clearButtonLabel
            }
            filterPills(filters: $filters) {
                filter
                pills {
                    label
                    value
                    facetGroupName
                }
            }
            suggestedFacets {
                title
                facetGroupName
            }
            page {
                number
                count
                results {
                    count
                }
            }
            finance {
                hpGuideLink
                pcpGuideLink
            }
        }
    }
`
